import * as React from 'react';
import { withModal } from 'components/modal/ModalHOC';

import type { MessengerAttachment } from 'types';

import { WITH_GALLERY_MODAL_CONFIG } from 'utils/gallery';

import MediaPreview from 'components/MediaPreview';

const DivWithModal = withModal(<div />, WITH_GALLERY_MODAL_CONFIG);

type Props = {
  data: Array<MessengerAttachment>
};

const VisualsPanel = ({
  data
}: Props) => {
  const galleryItems = data.map(item => ({
    type: 'cloudinary-image',
    assetUrl: item.url,
    url: item.url
  }));

  return (
    <section className="visuals-panel">
      <ul className="visuals-panel__thumbnails">
        {
          data.map((item, index) => {
            const mediaPreviewItem = {
              id: item.key,
              url: item.url,
              format: 'image'
            };

            return (
              <li
                key={item.key}
              >
                <DivWithModal
                  className="visuals-panel__thumbnails-image"
                  title={item.name}
                  modalContentProps={{
                    items: galleryItems,
                    currentPosition: index
                  }}
                >
                  <MediaPreview
                    attachment={mediaPreviewItem}
                    width={78}
                    height={78}
                  />
                </DivWithModal>
              </li>
            );
          })
        }
      </ul>
    </section>
  );
};

export default VisualsPanel;
